import { render, staticRenderFns } from "./KolDetail.vue?vue&type=template&id=0c06cce4&scoped=true"
import script from "./KolDetail.vue?vue&type=script&lang=js"
export * from "./KolDetail.vue?vue&type=script&lang=js"
import style0 from "./KolDetail.vue?vue&type=style&index=0&id=0c06cce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06cce4",
  null
  
)

export default component.exports